import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    await new Promise(r => setTimeout(r, 300));
    const result = login(email, password);
    if (!result.ok) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div>
        <form className="login-card" onSubmit={handle}>
          <div className="login-logo">
            <div className="login-logo-mark">⬡ ConstructPro</div>
            <div className="login-logo-sub">Project Management Suite</div>
          </div>

          {error && <div className="login-error">⚠ {error}</div>}

          <div className="form-group" style={{ marginBottom: 14 }}>
            <label>Email</label>
            <input type="email" autoFocus value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com" required />
          </div>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required />
          </div>
          <button className="btn btn-primary w-full" style={{ justifyContent: 'center', padding: '10px' }} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>

          <div style={{ marginTop: 24, padding: '14px', background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', fontSize: 12 }}>
            <div style={{ color: 'var(--text-muted)', marginBottom: 8, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em' }}>Demo Accounts</div>
            {[
              { role: 'Admin',    email: 'admin@constructpro.app',  pw: 'admin1234' },
              { role: 'PM',       email: 'pm@constructpro.app',     pw: 'pm1234' },
              { role: 'Engineer', email: 'eng@constructpro.app',    pw: 'eng1234' },
              { role: 'Viewer',   email: 'viewer@constructpro.app', pw: 'view1234' },
            ].map(u => (
              <div key={u.role} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--blue-text)', minWidth: 70 }}>{u.role}</span>
                <span style={{ color: 'var(--text-secondary)', cursor: 'pointer', fontFamily: 'var(--mono)', fontSize: 11 }}
                  onClick={() => { setEmail(u.email); setPassword(u.pw); }}>
                  click to fill ↑
                </span>
              </div>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}
